import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { useCallback } from 'react';

import type { TDataCity } from 'shared/types/TUserAddressFields';
import { CityAddressField } from 'shared/ui/AddressFields';

import type { TPassportFormFields } from 'entities/creditForm';

import styles from './Region.module.scss';

export const Region: FC<IFieldFactoryProps> = (props) => {
  const { getValues, setValue } = useFormContext<TPassportFormFields>();

  const onInitialSuggestsLoad = useCallback(
    (option: Dictionaries.TSelectOption<string, TDataCity>) => {
      setValue('region', option);
    },
    [setValue],
  );

  return (
    <div className={styles.regionField}>
      <CityAddressField
        {...props}
        initialValue={getValues('region')}
        onInitialSuggestsLoad={onInitialSuggestsLoad}
      />
    </div>
  );
};
